import { Building2 } from 'lucide-react';

/**
 * Czytelna nazwa zajezdni z kodu GAiT („GAiT z.H” → „Hallera”, „DyspA” → „Dyspozytorzy Autobusy”)
 * — te same nazwy co w słowniku zajezdni i rubryce formularza (B-308). Nieznany kod
 * zostaje bez zmian. Wspólne dla kartotek kierowców i pojazdów.
 */
const DEPOT_NAMES: Record<string, string> = { H: 'Hallera', W: 'Wrzeszcz', N: 'Nowy Port' };
const DEPOT_EXACT: Record<string, string> = { dyspa: 'Dyspozytorzy Autobusy', dyspt: 'Dyspozytorzy Tramwaje' };

export function depotLabel(code?: string | null): string | null {
  if (!code) return null;
  const exact = DEPOT_EXACT[code.trim().toLowerCase()];
  if (exact) return exact;
  const m = /z\.\s*([A-Z])\b/i.exec(code);
  return (m && DEPOT_NAMES[m[1].toUpperCase()]) || code;
}

export function DepotChip({ code }: { code?: string | null }) {
  const label = depotLabel(code);
  if (!label) return null;
  return (
    <span title={`Zajezdnia: ${code}`}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold border bg-indigo-50 text-indigo-700 border-indigo-200 whitespace-nowrap">
      <Building2 className="h-3 w-3 shrink-0" />{label}
    </span>
  );
}
